// ADR-108 — mirrors of radar-api `src/utils/benchReportDimensions.js` used by the
// bench reports' data-driven Business Unit filter.

/** `report` parameter of GET /reports/bench/facets. */
export const BENCH_REPORT_KEYS = {
  BENCH: 'bench',
  BENCH_ENTRY_LAG: 'benchEntryLag',
};

/** `facets` parameter of GET /reports/bench/facets. */
export const BENCH_REPORT_FACETS = {
  BUSINESS_UNITS: 'businessUnits',
  POSITIONS: 'positions', // ADR-110 — Bench Report only
};

/** buScope the bench reports send with a Business Unit filter — facets must use the same. */
export const BENCH_REPORT_BU_SCOPE = 'hierarchy';

/** Which count a business-unit option displays (matches the buScope the page sends). */
export const FACET_COUNT_MODES = {
  SUBTREE: 'subtree',
  DIRECT: 'direct',
};

export const BENCH_BUSINESS_UNIT_COUNT_TOOLTIP = 'Individuals on bench in this business unit, including sub-units';
export const BENCH_BUSINESS_UNIT_EMPTY_LABEL = 'No business units with individuals on bench';

// ADR-110 — Position filter of the Bench Report.
export const BENCH_POSITION_COUNT_TOOLTIP = 'Individuals on bench with this position in the selected Cluster and Business Unit';
export const BENCH_POSITION_EMPTY_LABEL = 'No positions — nobody on bench in this scope';
export const BENCH_POSITION_UNTYPED_GROUP_LABEL = 'Other positions';
